<template>
  <div v-if="!loading" class="flex wrap">
    <div class="fill">
      <h2>Open Auctions</h2>
      <div v-for="(bidtype, bidtypekey) in bids" :key="bidtypekey">
        <h3 v-if="Object.keys(bidtype).length > 0">{{ bidtypekey }}</h3>
        <div
          class="container p8"
          v-for="(bid, bidkey) in bidtype"
          :key="bidkey"
        >
          <div v-if="$store.state.items[bidtypekey][bidkey]">
            <div
              v-if="
                +bid >=
                +Object.keys($store.state.items[bidtypekey][bidkey].bids).sort(
                  (a, b) => +b - +a
                )[0]
              "
              class="success"
            >
              Winning
            </div>
            <div v-else class="warn flex wrap align-center between p4">
              Losing
              <button
                v-if="!increasebid[bidkey]"
                @click="
                  $set(
                    increasebid,
                    bidkey,
                    +Object.keys(
                      $store.state.items[bidtypekey][bidkey].bids
                    ).sort((a, b) => +b - +a)[0] + 1
                  )
                "
                type="button"
                class="xs-font"
              >
                <i class="fa fa-arrow-up r4"></i> bid
              </button>
              <input
                v-if="increasebid[bidkey]"
                type="number"
                v-model="increasebid[bidkey]"
                :min="
                  +Object.keys(
                    $store.state.items[bidtypekey][bidkey].bids
                  ).sort((a, b) => +b - +a)[0] + 1
                "
              />
              <button
                v-if="increasebid[bidkey]"
                @click="
                  loading = true;
                  $store
                    .dispatch('util', {
                      type: 'hash',
                      body: $store.state.auth.uid,
                    })
                    .then((h) => {
                      $set(
                        $store.state.items[bidtypekey][bidkey].bids,
                        increasebid[bidkey],
                        h
                      );
                      $store
                        .dispatch('update', {
                          id: bidkey,
                          type: bidtypekey,
                          data: $store.state.items[bidtypekey][bidkey],
                        })
                        .then(() => {
                          $store.state.user[$store.state.auth.uid].auctions[
                            bidtypekey + '_' + bidkey
                          ] = increasebid[bidkey];
                          $store
                            .dispatch('update', {
                              type: 'user',
                              id: $store.state.auth.uid,
                              data: $store.state.user[$store.state.auth.uid],
                            })
                            .then(() => {
                              $set(
                                bids[bidtypekey],
                                bidtype,
                                increasebid[bidkey]
                              );
                              increasebid[bidkey] = false;
                              $store
                                .dispatch('query', {
                                  type: 'item',
                                  collection: bidtypekey,
                                  id: bidkey,
                                })
                                .then(
                                  () =>
                                    $set(
                                      $store.state.counts,
                                      'auctions',
                                      $store.state.counts.auctions + 1
                                    ),
                                  (loading = false)
                                );
                            });
                        });
                    });
                "
                type="button"
                class="xs-font"
              >
                Commit Bid
              </button>
            </div>
            <router-link :to="`/i/${bidtypekey}/${bidkey}`">{{
              $store.state.items[bidtypekey][bidkey].basics.title
            }}</router-link>
            <div>
              Ending
              <itime
                :timestamp="
                  $store.state.items[bidtypekey][bidkey].purchases[
                    'auction end'
                  ]
                "
              />
            </div>
            <div
              :class="
                +bid >=
                +Object.keys($store.state.items[bidtypekey][bidkey].bids).sort(
                  (a, b) => +b - +a
                )[0]
                  ? 'success-text'
                  : 'warn-text'
              "
            >
              Your Bid
              {{
                Intl.NumberFormat("us-US", {
                  style: "currency",
                  currency: "USD",
                }).format(bid)
              }}
            </div>
            <div>
              High Bid
              {{
                Intl.NumberFormat("us-US", {
                  style: "currency",
                  currency: "USD",
                }).format(
                  Object.keys($store.state.items[bidtypekey][bidkey].bids).sort(
                    (a, b) => +b - +a
                  )[0]
                )
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fill">
      <h2>Closed Auctions</h2>
      <div v-for="(overtype, overtypekey) in over" :key="'over' + overtypekey">
        <h3>{{ overtypekey }}</h3>
        <div
          class="container p8"
          v-for="(overbid, overbidkey) in overtype"
          :key="overbidkey"
        >
          <div v-if="$store.state.items[overtypekey][overbidkey]">
            <div
              v-if="
                typeof overbid !== 'number' ||
                +overbid >=
                  +Object.keys(
                    $store.state.items[overtypekey][overbidkey].bids
                  ).sort((a, b) => +b - +a)[0]
              "
              class="success flex between align-center p4"
            >
              Won
              <span
                v-if="
                  !$store.state.items[overtypekey][overbidkey].purchases[
                    'auction complete'
                  ]
                "
              >
                Your Bid
                <span>
                  {{
                    Intl.NumberFormat("us-US", {
                      style: "currency",
                      currency: "USD",
                    }).format(overbid)
                  }}
                </span>
                <button
                  v-if="!increasebid[overbidkey]"
                  @click="
                    $set(
                      $store.state.items[overtypekey][overbidkey].purchases,
                      'cost',
                      +overbid
                    );
                    addToCart($store.state.items[overtypekey][overbidkey], 1);
                  "
                  type="button"
                  class="xs-font"
                >
                  <i class="fa fa-handshake r4"></i> Complete Transaction
                </button>
              </span>
              <router-link
                :to="`/orders/${$store.state.items[overtypekey][overbidkey].purchases['auction complete']}`"
                v-else
                >Paid, Order:
                {{
                  $store.state.items[overtypekey][overbidkey].purchases[
                    "auction complete"
                  ]
                }}</router-link
              >
            </div>
            <div v-else class="warn flex wrap align-center between p4">
              Lost
            </div>
            <router-link :to="`/i/${overtypekey}/${overbidkey}`">{{
              $store.state.items[overtypekey][overbidkey].basics.title
            }}</router-link>
            <div>
              Ended
              <itime
                :timestamp="
                  $store.state.items[overtypekey][overbidkey].purchases[
                    'auction end'
                  ]
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      bids: {},
      over: {},
      increasebid: {},
      typeslength: 0,
      bidslength: 0,
    };
  },
  methods: {
    // todo add item to user's cart automatically
    addToCart(item, qty) {
      if (this.$store.state.user[this.$store.state.auth.uid].cart && this.$store.state.user[this.$store.state.auth.uid].cart[item.id])
        return this.$set(this.$store.state.show, "cart", true);
      else
        this.$store.dispatch("query", {
          type: "user",
          id: this.$store.state.auth.uid,
        });
      if (!item.purchases.cost) {
        item.purchases.cost = this.customAmount;
      }
      // if user is logged in,
      if (this.$store.state.user[this.$store.state.auth.uid]) {
        // and does not have a cart already,

        if (!this.$store.state.user[this.$store.state.auth.uid].cart) {
          this.$set(
            this.$store.state.user[this.$store.state.auth.uid],
            "cart",
            {
              [item.id]: [
                item.type,
                item.id,
                item.purchases,
                qty,
                item.user,
                item.basics.title,
              ],
            }
          );

          // or does have items in the cart
        } else if (
          this.$store.state.user[this.$store.state.auth.uid].cart[item.id]
        ) {
          this.$set(
            this.$store.state.user[this.$store.state.auth.uid].cart,
            item.id,
            [
              item.type,
              item.id,
              item.purchases,
              this.$store.state.user[this.$store.state.auth.uid].cart[
                item.id
              ][3] + qty,
              item.user,
              item.basics.title,
            ]
          );

          // else user has cart but not this item
        } else {
          this.$set(
            this.$store.state.user[this.$store.state.auth.uid].cart,
            item.id,
            [
              item.type,
              item.id,
              item.purchases,
              qty,
              item.user,
              item.basics.title,
            ]
          );
        }
        delete this.$store.state.user[this.$store.state.auth.uid].user; // remove this.user stragler
        this.$store.state.user[this.$store.state.auth.uid].type = "user";

        // save updated user data
        var saveObj = {
          type: "user",
          id: this.$store.state.auth.uid,
          // noReload: true,
          data: this.$store.state.user[this.$store.state.auth.uid],
        };
        this.$store.dispatch("update", saveObj).then(() => {
          // cheat to update the cart
          this.$set(this.$store.state.show, "cart", false);
          setTimeout(() => {
            this.$set(this.$store.state.show, "cart", true);
          }, 0);
        });
      } else {
        this.$store.state.anon.cart = JSON.parse(
          window.localStorage.getItem("cart")
        )
          ? JSON.parse(window.localStorage.getItem("cart"))
          : null;
        !this.$store.state.anon.cart
          ? this.$set(this.$store.state.anon, "cart", {
              [item.id]: {
                [Date.now()]: [
                  item.type,
                  item.id,
                  item.purchases,
                  qty,
                  item.user,
                  item.basics.title,
                ],
              },
            })
          : !this.$store.state.anon.cart[item.id]
          ? this.$set(this.$store.state.anon.cart, item.id, {
              [Date.now()]: [
                item.type,
                item.id,
                item.purchases,
                qty,
                item.user,
                item.basics.title,
              ],
            })
          : this.$set(this.$store.state.anon.cart[item.id], Date.now(), [
              item.type,
              item.id,
              item.purchases,
              qty,
              item.user,
              item.basics.title,
            ]);
        localStorage.setItem(
          "cart",
          JSON.stringify(this.$store.state.anon.cart)
        );
        this.$set(this.$store.state.show, "cart", false);
        setTimeout(() => {
          this.$set(this.$store.state.show, "cart", true);
        }, 0);
      }
    },
  },
  mounted() {
    Object.entries(
      this.$store.state.user[this.$store.state.auth.uid].auctions
    ).map((x) => {
      const type = x[0].split("_")[0],
        id = x[0].split("_")[1];
      !this.bids[type] ? (this.bids[type] = {}) : null;
      !this.bids[type][id] ? (this.bids[type][id] = x[1]) : null;
      typeof x[1] == "number" &&
      typeof this.bids[type][id] == "number" &&
      +x[1] > +this.bids[type][id]
        ? (this.bids[type][id] = +x[1])
        : null;
    });
    this.typeslength = Object.keys(this.bids).length;
    Object.entries(this.bids).map((b, bi) => {
      this.bidslength = Object.keys(b[1]).length;
      Object.entries(b[1]).map((c, ci) => {
        this.$store
          .dispatch("query", { type: "item", collection: b[0], id: c[0] })
          .then((i) => {
            if (
              +new Date(i.purchases["auction end"]).getTime() <=
              +new Date().getTime()
            ) {
              !this.over[i.type] ? (this.over[i.type] = {}) : null;
              this.$set(
                this.over[i.type],
                i.id,
                this.$store.state.items[i.type][i.id].purchases[
                  "auction complete"
                ]
                  ? this.$store.state.user[this.$store.state.auth.uid].auctions[
                      i.type + "_" + i.id
                    ]
                  : Object.keys(
                      this.$store.state.items[i.type][i.id].bids
                    ).sort((a, b) => +b - +a)[0]
              );
              this.$delete(this.bids[i.type], i.id);
            }
            this.loading = !(
              ci === this.bidslength - 1 && bi === this.typeslength - 1
            );
          });
      });
    });
  },
};
</script>